import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as styleHelpersStyles } from '../../../assets/style-helpers.scss';
import { styles as textHelpersStyles } from '../../../assets/text-helpers.scss';
import { styles } from './template.scss';

export const templateIntegrationSuccess = document.createElement('template');

templateIntegrationSuccess.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styleHelpersStyles}</style>
  <style>${textHelpersStyles}</style>
  <style>${styles}</style>
  <div >
        <img src="app/webcomponents/assets/images/success.svg" class="mb-2"/>
        <div id="success-title" class="text-semibold mb-2"></div>
        <p id="success-description" class="mb-2"></p>
        <div id="included-sensors-title" class="mb-2"></div>
        <ul id="included-sensors" ></ul>
        <div id="extra-info"></div>
    </div>
  </div>
`;
